module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAA0ElEQVQoU2OcEPPVj/Evw0wGRgYJBnzgP8OL/8wM6YwTI78+J6gYZtB/hheME6O+/sdrMpokQQ0yWowMLmnsDJu6fzK8e/qfAayBmZWBQceZheHagT8Mv38gjAQp9i3hYPjw4h/D2pafDL++MUA08IszMsR0cTC8uPuPYVPXT7AmZMXr238y/PgMMQjuJCUTJgbPXHawpnNbfjN45LCDTUZWjKIBxIFpYmZhZHj98C+GYgwNYE3GTAyadiwMe+f8gjsDOaAIhhJ6kJMecaQmDQBaQWzvbU+GiQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/login-register/agree.png
// module id = 425
// module chunks = 1